// extracted by mini-css-extract-plugin
export const infoProducts = "products-module--infoProducts--3bFwj";
export const section = "products-module--section--1E7Az";
export const header = "products-module--header--3Wc_O";
export const columns = "products-module--columns--22djS";
export const label = "products-module--label--1E11w";
export const servicesList = "products-module--servicesList--bGtg5";